module.exports = __webpack_public_path__ + "img/rosa_sudeck_2.f270adc0.jpg";